import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { message, Upload, Switch, Select, DatePicker, Form, Input } from 'antd';
import { LeftCircleOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import {app} from '../../config';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';

const { TextArea } = Input;
const Addcausecategory = () => {
  const { t } = useTranslation(['common']);
  const [addUserResp, setAddUserResp] = useState({});
  const [show, setShow] = useState(false);
  const [uploadedImg, setUploadedImg] = useState('');
  const [uploadLogo, setuploadLogo] = useState(true);
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [causeObj, setCauseObj] = useState({
    causeCategory: '',
    isActive: ''
  });
  let navigate = useNavigate();

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const token=getTokenfromUserObj();
  const headers={auth:token};
  let user = JSON.parse(localStorage.getItem('user'));
  
  const handleuploadChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      info.file?console.log(info.file.response.data.Location):console.log("Not found"); 
      info.file?setUploadedImg(info.file.response.data.Location):" "
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setuploadLogo(false);
        setImageUrl(url);
      });
    }
  };
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  // console.log(causeCat[0].cause_category);

  const uploadData=async(uploadObj)=>{
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/cause/causecat/add`, uploadObj,{headers:{auth:token}});
      if (res.data.statusCode === 200) {
        setAddUserResp(res.data);
        setTimeout(() => {
          navigate('/cause/categories');
        }, 1000);
      }
    } catch (err) {
      console.log(err);
      setShow(false)
      if(err.response.status&&err.response.data.statusCode)message.error(err.response.data.data)
    }
  }
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onFinish = (values) => {
    console.log('Success:', values);

    setCauseObj({
      causeCategory: values.causeCategory ? values.causeCategory : '',
      displayPosition: values.displayPosition ? values.displayPosition : 1000, 
      image:uploadedImg? uploadedImg : '',
      isActive: values.isActive === true ? 1 : 0,
      createdByUserId:user.userId
    });
    setShow(true);
  };
  console.log(causeObj);
  const submitData = () => {
    console.log('calling');
    if (Object.keys(causeObj).length > 0) {
      uploadData(causeObj);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  function goBack() {
    navigate('/cause/categories',{replace:true});
   }
   window.addEventListener('popstate', goBack);
  return (
    <div class='row mt-4 w-75 tbl'>
   <div class='row topbar ' style={{ height: '70px' }}>
          <div class='col-lg-4 fs-3 fw-bold'>
            {' '}
          
            <LeftCircleOutlined
              onClick={() => {
                navigate('/cause/categories');
              }}
              className='mt-3 ml-4 back-icon'
              style={{ fontSize: '38px' }}
            />
          </div>
          <div class='col-lg-7 fs-3 fw-bold '>
            <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Add Cause Catergory')} </h2>
          </div>{' '}
        </div>
      <div class="col-lg-11 mb-5 ">
      <div class='col-lg-9 align-self-center mt-2 mb-4 mt-4'>
        <Form
          name='basic'
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          initialValues={{
            remember: true,
            // ['id']: 1,
            // ['causename']: 'Hammad',
            // ['causeCategory']:'test', 
            ['isActive']: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <Form.Item  
            colon={false}
            label='Cause Category'
            name='causeCategory'
            rules={[
              {
                required: true,
                message: 'Please input your username!',
              },
            ]}
          >
            <Input placeholder='Enter Cause Category' maxLength={20} />
          </Form.Item>
          <Form.Item
              colon={false}
              label='Display Position'
              name='displayPosition'
              rules={[
                {
                  required: false,
                  message: 'Enter display position',
                },
              ]}
            >
              <Input placeholder='Enter display position' min={1} type='number' maxLength={20} />
            </Form.Item>
          <Form.Item label='Image'   colon={false}  name='image'>
            <Upload
              // name="avatar"
              listType='picture-card'
              className='avatar-uploader'
              showUploadList={false}
              action={`${app.URL}/upload/causecatimage`}
              headers={headers}
              beforeUpload={beforeUpload}
              onChange={handleuploadChange}
            >
            
                {uploadLogo ? 
              loading?uploadButton:uploadButton
              : (
                <img
                  src={imageUrl}
                  alt='avatar'
                  style={{
                    width: '100%',
                  }}
                />
              ) }
            </Upload>
          </Form.Item>

          <Form.Item label='Active' valuePropName='checked'  colon={false} name='isActive'>
            <Switch />
          </Form.Item>
          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
            colon={false}
          >
             {addUserResp.statusCode === 200 ? (
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title className='text-center'>Success</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>{addUserResp.message}</Modal.Body>
                  <Modal.Footer></Modal.Footer>
                </Modal>
              ) : addUserResp.statusCode === 400 ? (
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title className='text-center'>Failed</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>{addUserResp.data.message}</Modal.Body>
                  <Modal.Footer></Modal.Footer>
                </Modal>
              ) : (
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>Are you sure you want to add Cause Category?</Modal.Body>
                  <Modal.Footer>
                    <Button variant='secondary' onClick={handleClose}>
                      Cancel
                    </Button>
                    <Button variant='primary' htmlType='submit' onClick={submitData}>
                      Save Changes
                    </Button>
                  </Modal.Footer>
                </Modal>
              )}
            <button type='primary' class='btn btn-primary button' htmlType='submit'>
              Add
            </button>
          </Form.Item>
        </Form>
      </div>
      </div>
    </div>
  );
};

export default Addcausecategory;
